import React from 'react';
import { TriangleSlider } from '../../slider';
import { AppSkinProps } from '../../../types/decisions';
import { useLocation } from 'react-router-dom';

const AppCriteriaFields = ({
    criteriaData,
    onSliderChange,
    onChangeCommitted,
    hideTitle = false,
}: AppSkinProps & {
    hideTitle?: boolean;
    onChangeCommitted?: () => void;
}) => {
    const location = useLocation();
    const isDisabled = location.pathname.startsWith('/patient-choice');

    return (
        <>
            {!hideTitle && <h2>Tradeoffs</h2>}
            {criteriaData.fields.map(({
                id,
                name,
                hide_importance,
            }, idx) => (
                <div
                    key={id}
                    className={`app-criteria-field ${hide_importance ? 'hidden' : ''}`}
                >
                    <label>{typeof name !== 'object' ? name : name.value}
                        <TriangleSlider
                            name={id}
                            min={0}
                            max={100}
                            step={1}
                            value={+criteriaData.fields[idx].importance}
                            onChange={(_, value) => onSliderChange(value as number, id)}
                            onChangeCommitted={onChangeCommitted}
                            disabled={isDisabled}
                        />
                    </label>
                </div>
            ))}
        </>
    );
};

export default AppCriteriaFields;